import { account, error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FeeBasedTransferSourceOptionsQuery = gql`
  query FeeBasedTransferSourceOptions {
    transferOptions(input: { includeExternalDebitCardDestinations: true }) {
      __typename
      ... on TransferOptions {
        source {
          __typename
          ... on GroupedAccounts {
            internal {
              ...account
            }
            external {
              ...account
            }
          }
        }
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${account}
  ${error}
`;

export default FeeBasedTransferSourceOptionsQuery;
